import { Product } from 'types/productType';
import { httpGet } from 'utils';

interface Params {
  offset?: number;
  limit?: number;
}

interface ExternalHoldingVT2Response {
  data: Product[];
  size?: number;
}

export const fetchExternalHoldings = (config?: Params) =>
  httpGet<ExternalHoldingVT2Response, Params>('portal/ExternalHoldings', config);
